import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EErrorMessage',
    props: {
        position: { default: 'left' },
        message: {}
    },
    setup: function (__props) {
        var props = __props;
        var messageClass = computed(function () {
            return {
                left: 'justify-start',
                center: 'justify-center',
                right: 'justify-end',
            }[props.position];
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_Transition, { name: "zoom-in-top" }, {
                default: _withCtx(function () { return [
                    (_ctx.message)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([[
                                    messageClass.value
                                ], "mt-2 text-sm text-red-400 flex"])
                        }, _toDisplayString(_ctx.message), 3))
                        : _createCommentVNode("", true)
                ]; }),
                _: 1
            }));
        };
    }
});
